var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoTalon = function SvgLogoTalon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 80,
    fill: "none",
    viewBox: "0 0 288 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#logo-talon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120.153 51-6.349-16.55-2.995 7.84h4.382l3.127 3.933h-9.04L107.456 51h-4.49l1.925-4.776h-1.631l1.585-3.933h1.631L111.832 29h2.894c.735 0 1.389.44 1.664 1.122l8.444 20.877zM72.383 32.964 73.913 29h16.503v3.965zM79.068 51V32.965l4.342 1.676V51zM169.951 51l-3.928-4.353V34.471h4.523v10.562l1.78 2.001h5.921l1.982-1.981v-9.524a1.4 1.4 0 0 0-.413-.996l-1.158-1.158a1.4 1.4 0 0 0-.996-.412h-5.029c-.377 0-.73.146-.997.412l-1.091 1.092-4.096-1.856 3.118-3.095c.337-.335.786-.52 1.261-.52h8.714c.476 0 .926.185 1.264.521l3.311 3.285c.337.334.53.8.53 1.273v12.588l-4.366 4.332h-10.33zM141.729 29h-4.342v22h4.342z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.728 51 1.53-3.966h9.932L151.659 51zM210.843 29.378l.067 12.018.943 3.628-3.275-4.562-6.487-9.004-5.388-2.079v21.242h3.804v-15.13l10.901 15.13h3.239V30.846z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-talon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.383 29h142.266v22H72.383z"
  })))));
};
export default SvgLogoTalon;